module.exports = __webpack_public_path__ + "assets/img/位图@2x(2).d063216d.png";